import {
	conversationActions,
	notifyActions,
} from '../../../controller';
import { SocketTypeEnums } from '../../../../lib/enums';
import { catchErrorMessageForSocket } from '../../../../lib/socket-utils';

const {
	notifySocketErrorAction,
} = notifyActions;
const {
	CONVERSATION_ACK_GOT,
	CONVERSATION_COMMAND_GET_ERROR,
	CONVERSATION_TEXT_SIZE_ACK_UPDATED,
	CONVERSATION_TEXT_SIZE_COMMAND_UPDATE_ERROR,
	CONVERSATION_NORMAL_REPLY_ACK_CREATED,
	CONVERSATION_NORMAL_REPLY_COMMAND_CREATE_ERROR,
	CONVERSATION_QUICK_PATH_ACK_CREATED,
	CONVERSATION_QUICK_PATH_COMMAND_CREATE_ERROR,
	CONVERSATION_SMART_REPLY_ACK_CREATED,
	CONVERSATION_SMART_REPLY_COMMAND_CREATE_ERROR,
	CONVERSATION_ACK_CLOSED,
	CONVERSATION_COMMAND_CLOSE_ERROR,
	CONVERSATION_STATUS_EVENT_UPDATED,
	CONVERSATION_COLOR_MAPPING_EVENT_UPDATED,
	CONVERSATION_TEXT_SIZE_EVENT_UPDATED,
	CONVERSATION_SCORE_ACK_UPDATED,
	CONVERSATION_SCORE_COMMAND_UPDATE_ERROR,
	CONVERSATION_EVENT_CREATED,
	CONVERSATION_SESSION_ACK_CLEARED,
	CONVERSATION_SESSION_COMMAND_CLEAR_ERROR,
	CONVERSATION_SESSION_EVENT_CLEARED,
} = SocketTypeEnums;
const {
	fetchConversationAction,
	fetchConversationSuccessAction,
	fetchConversationFailedAction,
	updateConversationTextSizeSuccessAction,
	updateConversationTextSizeFailedAction,
	createNormalReplyConversationSuccessAction,
	createNormalReplyConversationFailedAction,
	createQuickPathConversationSuccessAction,
	createQuickPathConversationFailedAction,
	createSmartReplyConversationSuccessAction,
	createSmartReplyConversationFailedAction,
	closeConversationSuccessAction,
	closeConversationFailedAction,
	gradeConversationScoreSuccessAction,
	gradeConversationScoreFailedAction,
	clearConversationSessionSuccessAction,
	clearConversationSessionFailedAction,
	clearConversationSessionEventAction,
	updateConversationStatusAction,
	updateConversationColorMappingAction,
	updateConversationTextSizeEventAction,
	updateConversationAction,
} = conversationActions;

export function gotConversationReceiver(socket, store) {
	socket.on(CONVERSATION_ACK_GOT, (payload = {}) => {
		const { dispatch } = store;
		const { data: { conversation } = {} } = payload;

		dispatch(fetchConversationSuccessAction(conversation));
	});
}

export function getConversationErrorReceiver(socket, store) {
	socket.on(CONVERSATION_COMMAND_GET_ERROR, (payload = {}) => {
		const { dispatch } = store;
		const { data: error } = payload;
		const actionObjects = catchErrorMessageForSocket(error, fetchConversationFailedAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function gotCreateNormalReplayConversationReceiver(socket, store) {
	socket.on(CONVERSATION_NORMAL_REPLY_ACK_CREATED, (payload = {}) => {
		const { dispatch } = store;
		const { data: { conversation } = {} } = payload;

		dispatch(createNormalReplyConversationSuccessAction(conversation));
	});
}

export function createNormalReplayConversationErrorReceiver(socket, store) {
	socket.on(CONVERSATION_NORMAL_REPLY_COMMAND_CREATE_ERROR, (payload = {}) => {
		const { dispatch } = store;
		const { data: error } = payload;
		const actionObjects = catchErrorMessageForSocket(error, createNormalReplyConversationFailedAction, notifySocketErrorAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function createQuickPathConversationReceiver(socket, store) {
	socket.on(CONVERSATION_QUICK_PATH_ACK_CREATED, (payload = {}) => {
		const { dispatch } = store;
		const { data: { conversation } = {} } = payload;

		dispatch(createQuickPathConversationSuccessAction(conversation));
	});
}

export function createQuickPathConversationErrorReceiver(socket, store) {
	socket.on(CONVERSATION_QUICK_PATH_COMMAND_CREATE_ERROR, (payload = {}) => {
		const { dispatch } = store;
		const { data: error } = payload;
		const actionObjects = catchErrorMessageForSocket(error, createQuickPathConversationFailedAction, notifySocketErrorAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function createSmartReplyConversationReceiver(socket, store) {
	socket.on(CONVERSATION_SMART_REPLY_ACK_CREATED, (payload = {}) => {
		const { dispatch } = store;
		const { data: { conversation } = {} } = payload;

		dispatch(createSmartReplyConversationSuccessAction(conversation));
	});
}

export function createSmartReplyConversationErrorReceiver(socket, store) {
	socket.on(CONVERSATION_SMART_REPLY_COMMAND_CREATE_ERROR, (payload = {}) => {
		const { dispatch } = store;
		const { data: error } = payload;
		const actionObjects = catchErrorMessageForSocket(error, createSmartReplyConversationFailedAction, notifySocketErrorAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function updateConversationTextSizeAckUpdatedReceiver(socket, store) {
	socket.on(CONVERSATION_TEXT_SIZE_ACK_UPDATED, (payload = {}) => {
		const { dispatch } = store;
		const { data: { conversation } = {} } = payload;

		dispatch(updateConversationTextSizeSuccessAction(conversation));
	});
}

export function updateConversationTextSizeUpdateErrorReceiver(socket, store) {
	socket.on(CONVERSATION_TEXT_SIZE_COMMAND_UPDATE_ERROR, (payload = {}) => {
		const { dispatch } = store;
		const { data: error } = payload;
		const actionObjects = catchErrorMessageForSocket(error, updateConversationTextSizeFailedAction, notifySocketErrorAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function closeConversationReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_ACK_CLOSED, ({ data }) => {
		const { conversation } = data;

		dispatch(closeConversationSuccessAction(conversation));
	});
}

export function closeConversationErrorReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_COMMAND_CLOSE_ERROR, ({ data }) => {
		const { error } = data;
		const actionObjects = catchErrorMessageForSocket(error, closeConversationFailedAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function gradeConversationScoreReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_SCORE_ACK_UPDATED, (payload = {}) => {
		const { current, data: { score } = {} } = payload;

		dispatch(gradeConversationScoreSuccessAction(score, current));
	});
}

export function gradeConversationScoreErrorReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_SCORE_COMMAND_UPDATE_ERROR, ({ data }) => {
		const { error } = data;
		const actionObjects = catchErrorMessageForSocket(error, gradeConversationScoreFailedAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function clearConversationSessionReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_SESSION_ACK_CLEARED, () => {
		dispatch(clearConversationSessionSuccessAction());
	});
}

export function clearConversationSessionErrorReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_SESSION_COMMAND_CLEAR_ERROR, ({ data }) => {
		const { error } = data;
		const actionObjects = catchErrorMessageForSocket(error, clearConversationSessionFailedAction);

		actionObjects.forEach(actionObject => dispatch(actionObject));
	});
}

export function clearedConversationSessionEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_SESSION_EVENT_CLEARED, (payload = {}) => {
		const { data: { platformId, conversationid } = {} } = payload;

		dispatch(clearConversationSessionEventAction(platformId, conversationid));
	});
}

export function updatedConversationStatusEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_STATUS_EVENT_UPDATED, ({ data }) => {
		const { conversation } = data;

		dispatch(updateConversationStatusAction(conversation));
	});
}

export function updatedConversationColorMappingEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_COLOR_MAPPING_EVENT_UPDATED, ({ data } = {}) => {
		dispatch(updateConversationColorMappingAction(data));
	});
}

export function updatedConversationTextSizeEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_TEXT_SIZE_EVENT_UPDATED, (payload = {}) => {
		const { data: { conversation = {} } = {} } = payload;

		dispatch(updateConversationTextSizeEventAction(conversation));
	});
}

export function conversationEventReceiver(socket, store) {
	const { dispatch } = store;

	socket.on(CONVERSATION_EVENT_CREATED, (payload = {}) => {
		const { data: { conversation = {} } = {} } = payload;

		dispatch(fetchConversationAction());
		dispatch(updateConversationAction(conversation));
	});
}
